declare var Cookiebot;
export default window.Cookiebot;